import { Box, SxProps } from '@mui/material';
import { BaseTheme } from 'design-system';
import { useProductIconSrc } from 'hooks/useProductIconSrc';

interface ProductIconProps {
  sku: string;
  label?: string;
  className?: string;
  sx?: SxProps<BaseTheme>;
  size?: number;
}

const ProductIcon = ({ sku, label, sx = {}, className = '', size = 30 }: ProductIconProps) => {
  const src = useProductIconSrc(sku?.toLowerCase(), label);
  if (!src) {
    return null;
  }
  return (
    <>
      <Box
        component="img"
        src={src}
        sx={{
          position: 'relative',
          width: size,
          height: size,
          padding: (theme) => theme.spacing(0.25),
          ...sx,
        }}
        className={className}
        alt=""
      />
    </>
  );
};

export default ProductIcon;
